<template>
  <div>
    <div class="tabscont">
      <button
        id="tablink-1"
        class="bar-item tablink bar-item-color tst-notes-tab"
        @click="openTab('tablink-1','Logs')"
      >Notes</button>
      <button id="tablink-2" class="bar-item tablink tst-issues-tab" @click="openTab('tablink-2','Issues')">Work Orders</button>
          
      <button style="display: none" id="tablink-3" class="bar-item tablink tst-issues-tab" @click="openTab('tablink-3','Maintenance')"> Maintenance </button>

    </div>

    <div id="Logs" class="tab logs logswindow">
      <div class>
        <!-- <div v-if="this.loadingMachine && this.loadingLogs" class="loader">Loading...</div> -->
        <!-- <div v-else> -->
          <!-- <div v-if="this.loadingMachine" class="loader">Loading...</div> -->
          <!-- <div v-else></div> -->
          <div v-if="this.loadingLogs" class="loader">Loading...</div>
          <div v-else>
            <Logs :loglist="this.loglist" :propertyid="this.propertyid" :logheaders="logsheaders" />
          </div>
        </div>
      </div>
    <!-- </div> -->
    <div id="Issues" class="tab issues" style="display: none">
      <!-- <div v-if="this.loadingIssues" class="loader">Loading...</div> -->
      <div v-if="this.loadingIssues == false">
        <IssuesLogViewer
          :propertyid="this.propertyid"
          :issuelist="this.issuelist"
          :issueheaders="this.issueheaders"
          :issuemode="'user'"
        />
      </div>
    </div>
    <div id="Maintenance" class="tab issues" style="display: none;"> 

      
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import EventService from "@/services/EventService.js";
import Logs from "@/components/logs/Logs.vue";
import IssuesLogViewer from "@/components/issues/IssuesLogViewer.vue";
import EventBus from '@/services/EventBus.js';

// import { all } from "q";

export default {
  components: {
    Logs,
    IssuesLogViewer
    },
  data() {
    return {
      machine: null,
      loglist: null,
      logsheaders: {},
      issuelist: null,
      issueheaders: {},
      loadingMachine: false,
      loadingLogs: false,
      loadingIssues: false,
      screenwidth: 0,
      propertyid: null,
      routeHistory: []
    };
  },
  mounted() {

  var section = this.$router.currentRoute.hash.replace("#", "");
        if(section == "tab1"){
              this.openTab('tablink-1','Logs');
        } else if(section == "tab2" && !this.$router.currentRoute.fullPath.includes("issue-")){
                  this.openTab('tablink-2','Issues');

        } else if(section.substring(0, 6) == "issue-") {
                this.openTab('tablink-2','Issues');
        } else if(section == "tab3"){
                this.openTab('tablink-3','Maintenance');

        }else{
               // this.$router.push("#tab1").catch(err => {});
                  this.openTab('tablink-2','Issues');
        }

  },


beforeRouteLeave: function(to, from, next) {

 //   this.connectToSignalr(null, "notmessagepage")
    next();
},
  methods: {

    connectToSignalr(id, pageName){
          $.connection.hub.qs = {
                'BearerToken': this.user.access_token
          
            };
          $.connection.hub.url = "https://givemeachance.xyz/signalr";

          var chat = $.connection.messageHub;

          chat.client.sendMessage = (message) => {
                  if(this.$route.fullPath.includes("issue")){
                        EventBus.$emit('comment-from-signalr', JSON.parse(message));
                  }else{
                     EventBus.$emit('log-from-signalr', JSON.parse(message));
                  }

          //  this.addLogLocally(JSON.parse(message))

            };
// in comments second parameter "issue"

            $.connection.hub.logging = true;

             if ($.connection.hub && $.connection.hub.state === $.signalR.connectionState.disconnected) {

            $.connection.hub.start({ withCredentials: false}).done(function () {
                //debugger
                console.log('Now connected, connection ID=' + $.connection.hub.id);
            }).done(  () => {
                     chat.server.connectedOnPage(id, pageName);
                }).fail(function (error) {
                       debugger
                       console.log('Invocation of NewContosoChatMessage failed. Error: ' + error);


                   });
             } else {
                chat.server.connectedOnPage(id, pageName);
             }
    },

   openTab(evt, tabName) {
      if(evt == "tablink-1"){
         //  this.$router.push("#tab1").catch(err => {});
         this.$router.replace("#tab1");
    }
      if(evt == "tablink-2" && !this.$router.currentRoute.fullPath.includes("issue-")){
         // this.$router.push("#tab2" ).catch(err => {});
          this.$router.replace("#tab2");
     }
       if(evt == "tablink-3"){
         // this.$router.push("#tab3" ).catch(err => {});
          this.$router.replace("#tab3");
     }
      this.screenwidth = document.documentElement.clientWidth;
      if (evt == "tablink-1" && this.screenwidth < 979) {
        this.$root.$emit("switched-notes-to-logs-mobile");
      }

      var i, x, tablinks;
      x = document.getElementsByClassName("tab");
      for (i = 0; i < x.length; i++) {
        x[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablink");
      for (i = 0; i < x.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(
          "bar-item-color",
          ""
        );
      }
      document.getElementById(tabName).style.display = "block";
      document.getElementById(evt).classList.add("bar-item-color");
    },
    configureBackButton(){
     this.routeHistory = this.$store.state.backbutton.routeHistory

     //if user has no routing history we define where to direct him
     if(this.routeHistory[1] == null || this.routeHistory[1] == undefined){
       //unshift instead of push because the back button function always goes to one before last
        this.routeHistory.unshift(`/Propertybyid/${this.propertyid}`)
        this.routeHistory.unshift("/DashboardAllProperties")

         }  
    },
    ...mapActions([ "newTitle"])
  },

  created() {
    // this.getLogsOfMachine(this.$route.params.MachineId);
    // this.getSpecificProperty(this.$route.params.propertyid);
    // this.getIssuesofMachine(this.$route.params.MachineId);
    this.loadingMachine = true;
    this.loadingLogs = true;
    this.loadingIssues = true;
    EventService.getSingleMachineInfo(this.$route.params.MachineId)
      .then(response => {
        this.machine = response.data;
        this.newTitle(this.machine.machinename);
      })
      .then(() => (this.loadingMachine = false));
    EventService.getLogsofMachine(this.$route.params.MachineId)
      .then(response => {
        this.loglist = response.data.loglists;
        this.propertyid = response.data.propertyid;
        this.configureBackButton();
        this.logsheaders = response.data;
      })
      .then(() => {
        this.loadingLogs = false

  });
    EventService.getIssuesofMachine(this.$route.params.MachineId, "all")
      .then(response => {
        this.issuelist = response.data.issueslist;
        this.issueheaders = response.data;
      })
      .then(() => {
        this.loadingIssues = false;
        })
  },
  computed: {
    // ...mapGetters(["getSpecificPropertybyId"])
        ...mapState({
      user: state => state.user.user
    })
  }
};
</script>
<style scoped>
.logswindow {
  overflow-x: hidden;
  padding-top: 34px;
}
.issues {
  overflow-x: hidden;
  padding-top: 34px;
}
.bar-item {
  padding: 8px 16px;
  color: black;
  border: 1px lightgray solid;
  border-radius: 2px;
  background-color: white;
  outline: 0;
  min-width: 150px;
  width: 25%;
  cursor: pointer;
}
.bar-item-color {
  background-color: #02746E;
  color: white;
}
.mmm {
  padding: 0%;
}

.tabscont {
  min-width: 100%;
  top: 60px;
  text-align: center;
  position: fixed;
  background-color: white;
  z-index: 2;
}

@media (min-width: 320px) and (max-width: 480px) {
  .mmm {
    margin: -15px;
  }
}
</style>
